<template>
  <nav class="navbar navbar-expand-md navbar-light bg-white">
    <BoxComponent w="100%" :pr-lg="24" :pl-lg="24" :pr="8" :pl="8">
      <FlexComponent :gap="24" align="center">
        <FlexComponent class="navbar__title" align="center" :gap="16">
          <router-link v-if="backTo" :to="backTo" class="navbar__back" aria-label="Go back">
            <ArrowIcon class="navbar__back-icon" />
          </router-link>
          <TypographyComponent v-if="pageTitle" variant="headline-medium" text-truncate class="navbar__title-text">
            {{ pageTitle }}
          </TypographyComponent>
        </FlexComponent>
        <AdvertiserSelector />
        <TypographyComponent variant="title-large" class="navbar__username">
          {{ user?.username || '' }}
        </TypographyComponent>
        <NotificationCenter />
      </FlexComponent>
    </BoxComponent>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { type RouteLocationRaw, useRoute } from 'vue-router'

import ArrowIcon from '@/assets/icons/arrow.svg?component'
import AdvertiserSelector from '@/components/AdvertiserSelector.vue'
import NotificationCenter from '@/components/NotificationCenter/NotificationCenter.vue'
import { usePageTitleStore } from '@/stores/page-title.stores'
import { useUserStore } from '@/stores/user.stores'
import { BoxComponent, FlexComponent, TypographyComponent } from '@/ui-library'

const route = useRoute()
const userStore = useUserStore()
const pageTitleStore = usePageTitleStore()

const pageTitle = computed(() => {
  if (pageTitleStore.override) {
    return pageTitleStore.override
  }
  if (route.meta.dynamicTitle) {
    return ''
  }
  return (route.meta.title as string | undefined) || ''
})
const backTo = computed(() => route.meta.back as RouteLocationRaw | undefined)
const user = computed(() => userStore.user)
</script>
<style lang="scss" scoped>
.navbar__title {
  flex: 1 0 0;
  min-width: 0;
}
.navbar__title-text {
  min-width: 0;
}
.navbar__back {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.navbar__back-icon {
  width: 24px;
  height: 24px;
  transform: rotate(180deg);
}
.navbar__username {
  @media screen and (max-width: 767px) {
    display: none;
  }
}
.navbar {
  border-bottom: 1px solid #eee;
  height: 65px;
  padding: 0 15px 0 64px;
  @include media-breakpoint-up(lg) {
    height: 80px;
    padding: 0 15px 0 80px;
  }
}
.navbar .logo-sign-brand {
  width: 30px;
  display: none;
  @include media-breakpoint-down(sm) {
    display: block;
  }
}
</style>
